let UTILS = require("../libs/utils.js");
var v7756;
var v7757;
module.exports = {
  id: "dom",
  name: "Domination",
  sub: "Dominate the Objective",
  alias: "dom",
  endStats: ["sid", "name", "score", "kills", "deaths", "caps", "reward"],
  leaderStats: ["score", "caps"],
  description: "Capture as many areas as possible by standing your position and defending it. The more time your team stay in the secured zone, the more points it wins.",
  descriptionLang: "game.mode.dom.description",
  dom: true,
  teams: true,
  noScoreC: true,
  captureTime: 10000,
  lockoutMlt: 1.5,
  perPlayerMlt: 0.2,
  collisionCheck: function (p9238, p9239) {
    for (var vLN01244 = 0; vLN01244 < p9238.map.manager.domzones.length; ++vLN01244) {
      v7756 = p9238.map.manager.domzones[vLN01244];
      if (p9239.collides(v7756)) {
        p9239.onZone = v7756.uid;
      }
    }
  },
  onKill: function (game, p9241, p9242, p9243) {
    if (p9243 && p9243 != p9242) {
      if (UTILS.isNumber(p9243.onZone)) {
        var v7759 = game.map.manager.domzones[p9243.onZone];
        if (v7759 && v7759.capturedBy == p9243.team) {
          game.players.score(p9243, 25);
          game.incMedal("Defender", p9243);
          p9243.send("am", [25, 25, 0, 1]);
          game.challenges.update(game, "defm", 1, null, p9243);
        }
      }
      if (UTILS.isNumber(p9242.onZone)) {
        var v7759 = game.map.manager.domzones[p9242.onZone];
        if (v7759 && v7759.capturedBy == p9242.team) {
          game.players.score(p9243, 25);
          game.incMedal("Attacker", p9243);
          p9243.send("am", [26, 25, 0, 1]);
          game.challenges.update(game, "atkm", 1, null, p9243);
        }
      }
    }
  }
};